import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RomaneioImpressaoPage } from '@/features/romaneio/page/impressao/padrao/RomaneioImpressaoPage';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.object({ idpk: StringToIdpkSchema });

export const Route = createFileRoute('/a/romaneio/impressao/padrao/$idpk')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const { idpk } = Route.useParams();

    return <RomaneioImpressaoPage idpk={idpk} />;
}
